import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'billingGroupManagementCompanies',
  inputShow: gql`
    query billingGroupManagementCompanies($input: BillingGroupManagementCompanyQueryInput) {
      billingGroupManagementCompanies(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Billing Group Management Companies',
    group: 'Facilities',
    order: 4,
  },
};
